import { Box, Grid, Stack } from "@mui/material";
import { CREATE_SERVICE_TICKET_HEADINGS } from "../../../../Constants/constants";
import { formatPhoneNumber } from "../../../../Services/helper";
import { ErrorMessage, ProfileInput, ProfileTypography } from "../../../../Styles/GlobalStyles";

export const ContactInfoVerification = ({
  formData,
  setFormData,
  formErrors,
  setFormErrors,
  otherReason,
  customerNotesError,
}: any) => {
  const handleChangePhoneNumber = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, phoneNumber: formatPhoneNumber(e.target.value) });
    setFormErrors({ phoneNumber: "" });
  };

  const handleChangeCustomerNotes = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, customerNotes: e.target.value });
    setFormErrors({ phoneNumber: "", secondaryPhone: "", customerNotes: "" });
  };

  return (
    <>
      <Box m={2}>
        <Grid container direction={"row"} my={1} gap={1} width={"100%"}>
          <Grid item xs={12} md={5.5} gap={4}>
            <ProfileTypography>Mobile Number</ProfileTypography>
            <ProfileInput
              required
              error={formErrors.phoneNumber ? true : false}
              name="phoneNumber"
              type="text"
              fullWidth
              placeholder="(###)-###-####"
              value={formData.phoneNumber}
              onChange={handleChangePhoneNumber}
            />
            {formErrors.phoneNumber && (
              <ErrorMessage error={formErrors?.phoneNumber ? true : false}>
                {formErrors?.phoneNumber}
              </ErrorMessage>
            )}
          </Grid>
        </Grid>
        {otherReason && (
          <Stack my={2} spacing={1}>
            <ProfileTypography>
              Please enter any additional information about your specific issues
            </ProfileTypography>
            <ProfileInput
              name="note"
              placeholder="Add Note"
              fullWidth
              type="text"
              value={formData.customerNotes}
              onChange={handleChangeCustomerNotes}
              multiline
              rows={3}
              hasError={formErrors?.customerNotes ? true : false}
            />
          </Stack>
        )}
        {formErrors.customerNotes && (
          <ErrorMessage error={formErrors?.phoneNumber ? true : false}>
            {formErrors?.customerNotes}
          </ErrorMessage>
        )}

        <Stack my={2} spacing={1}>
          <ProfileTypography>Note : </ProfileTypography>
          <ProfileTypography>{CREATE_SERVICE_TICKET_HEADINGS.note}</ProfileTypography>
        </Stack>
      </Box>
    </>
  );
};
